import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveCorrectWordsMutationVariables = Types.Exact<{
  correctWords: ReadonlyArray<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type SaveCorrectWordsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveCorrectWords: boolean };


export const SaveCorrectWordsDocument = gql`
    mutation SaveCorrectWords($correctWords: [String!]!) {
  saveCorrectWords(correctWords: $correctWords)
}
    `;
export type SaveCorrectWordsMutationFn = Apollo.MutationFunction<SaveCorrectWordsMutationPage, SaveCorrectWordsMutationVariables>;

/**
 * __useSaveCorrectWordsMutation__
 *
 * To run a mutation, you first call `useSaveCorrectWordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCorrectWordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCorrectWordsMutation, { data, loading, error }] = useSaveCorrectWordsMutation({
 *   variables: {
 *      correctWords: // value for 'correctWords'
 *   },
 * });
 */
export function useSaveCorrectWordsMutation(baseOptions?: Apollo.MutationHookOptions<SaveCorrectWordsMutationPage, SaveCorrectWordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCorrectWordsMutationPage, SaveCorrectWordsMutationVariables>(SaveCorrectWordsDocument, options);
      }
export type SaveCorrectWordsMutationHookResult = ReturnType<typeof useSaveCorrectWordsMutation>;
export type SaveCorrectWordsMutationResult = Apollo.MutationResult<SaveCorrectWordsMutationPage>;
export type SaveCorrectWordsMutationOptions = Apollo.BaseMutationOptions<SaveCorrectWordsMutationPage, SaveCorrectWordsMutationVariables>;